import styled from 'styled-components';
import { SColumn, SRow } from 'styles/layout';
import { SSearchInput as SInput } from 'components/Contact/ContactList/styles';

export const SActions = styled(SRow)`
    gap: 1rem;
`;

export const SWrapper = styled(SColumn)`
    gap: 3rem;
`;

export const SSearchInput = styled(SInput)`
    align-self: end;
    margin-top: 1rem;
`;

export const SCard = styled.div`
    background-color: ${({ theme }) => theme.color.grey.lighter};
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const SCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const SCardHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const SNameCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
`;

export const SCardLine = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const SCardLineLeft = styled.span`
    color: ${({ theme }) => theme.color.grey.light};
    font-weight: bold;
`;

export const SCardLineRight = styled.span`
    text-align: right;
`;
